import React from 'react';
import { Input } from 'syngenta-digital-cropwise-react-ui-kit';
import PropTypes from 'prop-types';
import AddressFields from '../AddressFields';

const AddCompany = ({ values, errors, onChange, onBlur, touched }) => {
  return (
    <>
      <div className="flex flex-col mb-5 w-1/2 pr-4 relative">
        <label
          htmlFor="owner-name"
          className="text-neutral-60 tracking-tighter text-sm mb-0.5"
        >
          Name<span className="text-remove">*</span>
        </label>
        <Input
          required
          name="name"
          id="owner-name"
          type="text"
          size="middle"
          value={values.name}
          onChange={onChange}
          onBlur={onBlur}
          status={touched?.name && errors?.name ? 'error' : undefined}
        />
        {touched?.name && errors?.name && (
          <span
            className="text-remove text-xs absolute"
            style={{ top: '100%' }}
          >
            {errors.name}
          </span>
        )}
      </div>
      <h3 className="text-base font-semibold block mb-4 mt-10px">Basic Info</h3>

      <div className="flex mb-5">
        <div className="flex flex-col w-full mr-8">
          <label
            htmlFor="legalName"
            className="text-neutral-60 tracking-tighter text-sm mb-0.5"
          >
            Legal Name
          </label>
          <Input
            type="text"
            size="middle"
            name="legalName"
            id="legalName"
            onChange={onChange}
            value={values.legalName}
          />
        </div>
        <div className="flex flex-col w-full">
          <label
            htmlFor="email"
            className="text-neutral-60 tracking-tighter text-sm mb-0.5"
          >
            Email Address
          </label>
          <Input
            type="text"
            size="middle"
            name="email"
            id="email"
            onChange={onChange}
            value={values.email}
            status={errors?.email && 'error'}
            caption={errors?.email}
          />
        </div>
      </div>
      <div className="flex flex-col gap-1 mb-5 w-1/2 pr-4">
        <div className="flex flex-col w-full">
          <label
            htmlFor="phone"
            className="text-neutral-60 tracking-tighter text-sm mb-0.5"
          >
            Phone Number
          </label>
          <Input
            type="text"
            size="middle"
            name="phone"
            id="phone"
            value={values.phone}
            onChange={onChange}
          />
        </div>
      </div>
      <h3 className="text-base font-semibold block mb-4">Address</h3>
      <div className="relative grid gap-x-4 -mr-4 grid-cols-4">
        <AddressFields />
      </div>
      <div className="relative mt-10">
        <label
          htmlFor="notes"
          className="text-neutral-60 tracking-tighter text-sm block mb-0.5"
        >
          Notes
        </label>
        <Input.TextArea
          value={values.notes}
          id="notes"
          name="notes"
          className="h-20"
          onChange={onChange}
        />
      </div>
    </>
  );
};

AddCompany.defaultProps = {
  errors: null,
  touched: null
};

AddCompany.propTypes = {
  values: PropTypes.shape({
    name: PropTypes.string,
    legalName: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    website: PropTypes.string,
    addressLineOne: PropTypes.string,
    addressLineTwo: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zipCode: PropTypes.string,
    notes: PropTypes.string
  }).isRequired,
  errors: PropTypes.objectOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  touched: PropTypes.objectOf(PropTypes.bool)
};

export default AddCompany;
